import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import intl from 'react-intl-universal';

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '45px',
    backgroundColor: theme.palette.background.paper,
    padding: '0',
    boxShadow: '0 2px 7px 0 rgba(0,0,0,0.03)',
  },
  tabsIndicator: {
    backgroundColor: '#000',
    bottom: '-2px',
    height: '3px',
    zIndex: 2,
  },
  fixed: {
    overflowX: 'initial',
  },
  tabsRoot: {
    // overflow: 'initial',
  },
  tabRoot: {
    textTransform: 'initial',
    fontSize: '1rem',
    fontWeight: theme.typography.fontWeightRegular,
    fontFamily: 'EYInterstate Light',
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$tabSelected': {
      color: '#000',
      fontWeight: theme.typography.fontWeightMedium,
      fontFamily: 'EYInterstate',
    },
    '&:focus': {
      color: '#000',
    },
  },
  tabSelected: {},
  typography: {
    padding: theme.spacing(3),
  },
  scroller: {
    overflowY: 'hidden',
  },
});

class EmployeeDetailTabPres extends React.Component {
  render() {
    const { classes, tab, onChange, relatedTabs } = this.props;

    return (
      <div className={classes.root}>
        <Tabs
          value={tab}
          onChange={onChange}
          classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator, fixed: classes.fixed, scroller: classes.scroller }}
          variant="scrollable"
          scrollButtons="auto">
          <Tab
            value="Information"
            classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
            label={intl.get('employees.tabs.information')}
          />
          {relatedTabs && relatedTabs.length > 0 && (
            <Tab
              value="Cases"
              classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
              label={intl.get('employees.tabs.cases')}
            />
          )}
          {relatedTabs.map((tab, index) => {
            return <Tab classes={{ root: classes.tabRoot, selected: classes.tabSelected }} label={tab.label} value={index} />;
          })}
        </Tabs>
      </div>
    );
  }
}

EmployeeDetailTabPres.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EmployeeDetailTabPres);
